import {
  formattedLicensePricingDataType,
  licensePricingDataApiResponseType,
} from 'types/purchaseLicenseModalTypes';

const currencyFormatter = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
});

const isPaymentMethodExpired = (
  expirationMonth: number,
  expirationYear: number,
): boolean => {
  const currentYear = Number(new Date().getFullYear().toString().slice(-2));
  const currentMonth = new Date().getMonth() + 1;

  if (!expirationMonth && !expirationYear) return false;
  if (currentYear > expirationYear) return true;
  if (currentYear === expirationYear && currentMonth > expirationMonth)
    return true;
  return false;
};

export const formatLicensePricingData = (
  licensePricingData: licensePricingDataApiResponseType,
  licenseQuantity: number,
): formattedLicensePricingDataType => {
  const licensePrice =
    licensePricingData?.licenseEstimation?.licenseUnitPrice ?? 0;
  const newRecurringChargesWithoutTaxesAndFees = licensePrice * licenseQuantity;
  const estimatedTaxesAndFees =
    (licensePricingData?.licenseEstimation?.estimatedTaxesAndFees ?? 0) *
    licenseQuantity;
  const totalCurrentMonthlyCharges =
    licensePricingData?.licenseEstimation?.totalCurrentCharges ?? 0;
  const totalNewMonthlyCharges =
    totalCurrentMonthlyCharges + newRecurringChargesWithoutTaxesAndFees;
  const proratedLicensePrice = Math.abs(
    licensePricingData?.licenseEstimation?.proratedLicenseUnitPrice ?? 0,
  );
  const proratedMonthlyAdjustment = proratedLicensePrice * licenseQuantity;
  const proratedEstimatedTaxesAndFees =
    Math.abs(licensePricingData?.licenseEstimation?.proratedTaxesAndFees ?? 0) *
    licenseQuantity;
  const totalDueToday = proratedMonthlyAdjustment;
  const lastFourDigitsOfPaymentMethod =
    licensePricingData?.paymentMethod?.lastFourDigits ?? '';
  const expirationMonth = Number(
    licensePricingData?.paymentMethod?.expiration?.substring(0, 2) ?? '',
  );
  const expirationYear = Number(
    licensePricingData?.paymentMethod?.expiration?.substring(2, 4) ?? '',
  );
  const paymentMethod =
    licensePricingData?.paymentMethod?.paymentMethodType ?? '';
  const eCheckSuffix = licensePricingData?.paymentMethod?.suffix;

  return {
    licensePrice: currencyFormatter.format(licensePrice),
    newRecurringChargesWithoutTaxesAndFees: currencyFormatter.format(
      newRecurringChargesWithoutTaxesAndFees,
    ),
    estimatedTaxesAndFees: currencyFormatter.format(estimatedTaxesAndFees),
    totalCurrentMonthlyCharges: currencyFormatter.format(
      totalCurrentMonthlyCharges,
    ),
    totalNewMonthlyCharges: currencyFormatter.format(totalNewMonthlyCharges),
    proratedLicensePrice: currencyFormatter.format(proratedLicensePrice),
    proratedMonthlyAdjustment: currencyFormatter.format(
      proratedMonthlyAdjustment,
    ),
    proratedEstimatedTaxesAndFees: currencyFormatter.format(
      proratedEstimatedTaxesAndFees,
    ),
    totalDueToday: currencyFormatter.format(totalDueToday),
    lastFourDigitsOfPaymentMethod,
    paymentMethod,
    eCheckSuffix,
    isPaymentMethodExpired: isPaymentMethodExpired(
      expirationMonth,
      expirationYear,
    ),
  };
};
